<template>
    <div class="ag-icon-header">
        <div class="ag-cell-label-container ag-icon-header__sort" :class="`ag-sort-${sort}`">
            <span
                v-if="!params.unsortable"
                aria-hidden
                class="ag-header-icon ag-header-label-icon"
                :class="`ag-sort-${sort}-icon`"
                @click="toggleSort"
            >
                <span role="presentation" :class="`ag-icon ag-icon-${sortShort}`" />
            </span>
            <icon v-if="params.iconComponent" :icon-name="params.iconComponent" />
        </div>
        <div
            v-if="params.enableFilterButton"
            ref="menuButton"
            class="ag-icon-header__menu-button"
            @click="onMenuClicked($event)"
        >
            <i class="fa ag-icon ag-icon-menu" />
        </div>
    </div>
</template>

<script>
// https://www.ag-grid.com/vue-grid/component-header/
export default {
    data() {
        return {
            sort: 'none',
            sortOptions: ['none', 'ascending', 'descending'],
        };
    },
    computed: {
        sortShort() {
            return this.sort.replace('ending', '');
        },
    },
    mounted() {
        this.params.column.addEventListener('sortChanged', this.onSortChanged);
        this.onSortChanged();
    },
    methods: {
        onMenuClicked() {
            this.params.showColumnMenu(this.$refs.menuButton);
        },

        onSortChanged() {
            if (this.params.column.isSortAscending()) {
                this.sort = 'ascending';
            } else if (this.params.column.isSortDescending()) {
                this.sort = 'descending';
            } else {
                this.sort = 'none';
            }
        },

        toggleSort(event) {
            const currentSortIndex = this.sortOptions.indexOf(this.sort);
            const newSort = this.sortOptions[(currentSortIndex + 1) % this.sortOptions.length];
            this.sort = newSort;
            this.params.setSort(this.sortShort, event.shiftKey);
        },
    },
};
</script>

<style lang="scss">
.ag-icon-header {
    display: flex;
    align-items: center;
    width: 100%;
    padding-right: 0.5rem;

    &__sort {
        margin-right: 0.5rem;
        justify-content: left !important;
        cursor: pointer;
    }

    &__menu-button {
        cursor: pointer;
        opacity: 0;
        transition: opacity 0.3s;
    }

    &:hover {
        .ag-icon-header__menu-button {
            opacity: 1;
        }
    }
}
</style>
